import $ from 'jquery';
import _ from 'underscore';

export default class Pagination {
	constructor(options = {}) {

		const el = '.js-pagination';
		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};
		const dataOptionKeys = [
		];
		const defaults = {
			next: '.js-pagination-next',
			prev: '.js-pagination-prev',
			link: '.js-pagination-link',
			item: '.js-pagination-item',
			disabled: 'pagination__link_state_disabled',
			active: 'pagination__link_state_active',
			list: '.js-pagination-list',
			dots: 'pagination__link_state_dots'

		};

		this.$el = $(el);

		if (!this.$el.length) {
			return false;
		}

		this.options = $.extend(true, {}, defaults, options, this.readDataOptions(dataOptionKeys));

		this.listCount = this.options.count ? this.options.count : 4;
		this.maxShowCount = this.options.showCount ? this.options.showCount : 5;
		this.currentPage = 1;
		this.pages = [];
		this.currentState = [];

		this.$list = $(this.$el.find(this.options.list));
		this.$linkItemTmp = _.template(_.unescape($('#linkItem').html().trim()), mustacheStyleSyntax);
		this.$nextButton = $(this.$el.find(this.options.next));
		this.$prevButton = $(this.$el.find(this.options.prev));
		this.$nextButton.on('click', e => { this.nextPage(e); });
		this.$prevButton.on('click', e => { this.prevPage(e); });
		this.initPages();
		this.checkPage();
	}

	setPage(e) {
		const target = e.target;
		this.currentPage = (Number(target.text) < 1) ? 1 : Number(target.text);
		this.checkPage();
		this.$el.trigger('changePage', this.currentPage);
	}

	checkPage() {

		const currentIndex = Math.floor(this.currentPage / this.maxShowCount);

		if ((this.maxShowCount * currentIndex + this.maxShowCount) >= this.listCount) {
			this.currentState = [];
			let i = this.listCount - (this.maxShowCount + 1);
			i = i < 0 ? 0 : i;
			if (this.maxShowCount < this.listCount) {
				this.currentState.push(this.pages[this.maxShowCount - this.maxShowCount]);
				this.currentState.push('...');
			}

			for ( i; i < this.listCount; i++) {
				this.currentState.push(this.pages[i]);
			}
		} else if ((this.maxShowCount * currentIndex + this.maxShowCount) < this.listCount) {
			this.currentState = [];
			for (let i = this.maxShowCount * currentIndex - 1; i < (this.maxShowCount * currentIndex + this.maxShowCount); i++) {
				this.currentState.push(this.pages[i]);
			}
			if (this.maxShowCount < this.listCount) {
				this.currentState.push('...');
				this.currentState.push(this.pages[this.pages.length - 1]);
			}

		}


		this.renderPages();
	}

	initPages() {

		this.pages = [];
		for (let i = 1; i <= this.listCount; i++ ) {
			this.pages.push(i);
		}
	}

	update(count, number) {
		this.listCount = count;
		this.currentPage = number;
		this.initPages();
		this.checkPage();
		this.renderPages();
		this.$el.trigger('changePage', this.currentPage);
	}

	renderPages() {

		let newNode;
		this.$list.empty();

		this.currentState.forEach(item => {
			$('.js-show-more').show();
			if (!item) {
				return;
			}

			newNode = $(this.$linkItemTmp({item: {number: item, state: ''}}));
			if (this.currentPage === item) {
				newNode.addClass(this.options.active);
			}

			if (item === '...') {
				newNode.addClass(this.options.dots);
			}

			this.$list.append(newNode);

			newNode.on('click', e => { this.setPage(e); });

			if (this.currentPage === this.listCount) {
				$('.js-show-more').hide();
			}

		});

	}

	nextPage = () => {
		this.currentPage++;
		this.currentPage = this.currentPage > this.listCount ? this.listCount : this.currentPage;
		this.checkPage();
		this.$el.trigger('changePage', this.currentPage);
	};

	prevPage() {
		this.currentPage--;
		this.currentPage = this.currentPage < 1 ? 1 : this.currentPage;
		this.checkPage();
		this.$el.trigger('changePage', this.currentPage);

	}

	readDataOptions(keys) {
		const ndd = this;
		const result = {};
		$.each(keys, function (i, key) {
			const val = ndd.$el.data(key);
			if (val !== void 0) {
				result[$.camelCase(key)] = val;
			}
		});
		$('.js-show-more').on('click', this.nextPage);
		return result;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/pagination/pagination.js
 **/